<template>
	<div class="tutorial-cat" :class="[{'no-click': !tooltipShowing }]">
		<v-popover
			trigger="manual"
			placement="right"
			:open="tooltipShowing"
			:autoHide="false"
		>
			<Cat
				ref="innerCat"
				:breed="breed"
				:initialState="initialState"
				:walkDistance="walkDistance"
				@fed="onFeed"
				@remove="remove"
				@walkComplete="completeEntrance"
			/>
			<template slot="popover">
				<transition name="fade" type="trantition">
					<component
						v-if="hasCurrentTooltip"
						:is="tooltipComponent"
						:clicksRemaining="clicksRemaining"
						:name="breed.title"
					/>
				</transition>
			</template>
		</v-popover>
	</div>
</template>

<script>
import Cat from '@/components/cat/Cat';
import tooltips from '@/mixins/tooltips';

export default {
	name: 'TutorialCat',
	mixins: [tooltips],
	components: {
		Cat,
	},
	props: {
		breed: {
			required: true,
			default: null,
		},
		walkDistance: {
			default: 0,
		},
		initialState: {
			default: "walking",
		},
	},
	data() {
		return {
			hasEntered: false,
			catIndex: null,
			clicksRemaining: 0,
		};
	},
	computed: {
		tooltipComponent() {
			return {
				template: this.tooltipMessage,
				props: ["clicksRemaining", "name"],
			};
		},
		hasCurrentTooltip() {
			return this.tooltipLocation === "cat" && this.tooltipCatIndex === this.catIndex && this.hasEntered;
		},
	},
	watch: {
		hasCurrentTooltip(hasCurrentTooltip) {
			if (hasCurrentTooltip) {
				this.showTooltip();
			}
		},
		clicksRemaining(clicksRemaining) {
			if (clicksRemaining === 0) {
				this.hideTooltip();
			}
		},
	},
	methods: {
		onFeed() {
			this.clicksRemaining -= 1;
		},
		completeEntrance() {
			this.hasEntered = true;

			if (this.hasCurrentTooltip) {
				this.$refs.innerCat.$once("fed", () => {
					this.hideTooltip();
				});
			}
		},
		setCatIndex(index) {
			this.catIndex = index;
		},
		remove() {
			this.$emit("remove");
		},
	},
	mounted() {
		this.clicksRemaining = this.breed.food_required;
	},
};
</script>

<style lang="scss" scoped>
	.tutorial-cat {
		width: 100%;
		height: 100%;
	}
</style>
<style lang="scss">
	.tutorial-cat {
		.v-popover,
		.trigger {
			width: 100%;
			height: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialCat.vue